import { getSDK } from '@littlebird/sdk';
import { useEffect } from 'react';

// The SDK fetches the card documents only once a client says it draws cards from them.
// Chat draws every card from them, so this asks whatever the flag says
export function useActionCardTemplates(): void {
  useEffect(() => {
    getSDK().stores.actionCards.wantTemplates();
  }, []);
}
